import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/globals.scss';
import * as Sentry from '@sentry/react';
import { App } from './app';
import './i18n'
import i18n, { loadDefaultLang } from './i18n'
import { callYaMetrika } from '@/utils/call-ya-metrika';

Sentry.init({
    dsn:
        process.env.NODE_ENV !== 'development'
            ? 'https://1eb8575cbe33d2270715b41595e35f84@sentry.travelask.ru/20'
            : undefined,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
        Sentry.globalHandlersIntegration({ onerror: true, onunhandledrejection: true }),
    ],
    tracesSampleRate: 1.0,
    environment: process.env.NODE_ENV,
    debug: process.env.NODE_ENV === 'development',
    replaysOnErrorSampleRate: 1.0,
});

if (typeof window !== 'undefined') {
    window.addEventListener('error', (event) => {
        Sentry.captureException(event.error);
    });

    window.addEventListener('unhandledrejection', (event) => {
        Sentry.captureException(event.reason);
    });

    window.addEventListener('appinstalled', _ => callYaMetrika('app_installed'))
}

i18n.on('initialized', async () => {
    await loadDefaultLang()
    const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
    root.render(
        process.env.NODE_ENV !== 'development' ? (
            <Sentry.ErrorBoundary
                fallback={<div>Something went wrong</div>}
                showDialog>
                <App />
            </Sentry.ErrorBoundary>
        ) : (
            <App />
        ),
    );
})
